import React, { useState, useCallback, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { OMStatusLayout, StatusLayout, SummaryLayout } from "../../../wm/components/transactions/dataentry/Layout";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';

import {
    Column,
    DataGrid,
    Grouping,
    FilterRow,
    Sorting,
    LoadPanel as GridLoadPanel,
    ColumnHeaderFilter,
    Selection,
} from "devextreme-react/data-grid";
import axios from "axios";
import DataSource from 'devextreme/data/data_source';
import { createStore } from 'devextreme-aspnet-data-nojquery';
function CustomerCredit(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const rootRef = useRef(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    // AROPENITEMHEADER.TRANSACTIONTYPE descriptions, from uIDD0021.CustomerLastInfo's
    // sType mapping. Keep this dense - a hole here is visited by find() as undefined and
    // throws on t.code, which used to blank the whole Summary tab.
    const TransactionType = [
        { code: 'A', value: 'Adjustment' },
        { code: 'C', value: 'Credit' },
        { code: 'D', value: 'Debit' },
        { code: 'F', value: 'Finance Charge' },
        { code: 'I', value: 'Invoice' },
        { code: 'M', value: 'Deposit Memo' },
    ];

    // uIDD0021.PAS:428-433 binds @OutBreak1Amt..@OutBreak6Amt to edt0/edt30/edt31/edt61/
    // edt91/edt121 by position. GetCustomerCreditInformation returns CreditBreaks in that
    // same order, so map by index - the SP's Label is display text and can be reworded.
    const AGING_BUCKET_FIELDS = ['under0', 'fromZeero', 'fromThirtyOne', 'fromSixtyOne', 'fromNintyOne', 'OverOneTwenty'];

    const initialFormFieldSummaryTotals = {

        invoiceMTD: 0,
        invoiceYTD: 0,
        invoiceLTD: 0,
        invoicePriorY: 0,

        paymentMTD: 0,
        paymentYTD: 0,
        paymentLTD: 0,
        paymentPriorY: 0,

        discountMTD: 0,
        discountYTD: 0,
        discountLTD: 0,
        discountPriorY: 0,

        creditMTD: 0,
        creditYTD: 0,
        creditLTD: 0,
        creditPriorY: 0,

        paidMTD: 0,
        paidYTD: 0,
        paidLTD: 0,
        paidPriorY: 0,

        paidDueDateMTD: 0,
        paidDueDateYTD: 0,
        paidDueDateLTD: 0,
        paidDueDatePrior: 0,

        postedMTD: 0,
        postedYTD: 0,
        postedLTD: 0,
        postedPriorY: 0,

        paidLateMTD: 0,
        paidLateYTD: 0,
        paidLateLTD: 0,
        paidLatePriorY: 0,

        avgDaysPayMTD: 0,
        avgDaysPayYTD: 0,
        avgDaysPayLTD: 0,
        avgDaysPayPriorY: 0,

        currentBalance: 0,
        lastStmBalance: 0,
        lastStmDate: 0,
        amt1: 0,
        transactionnumber: 0,
        lastPaymentDate: 0,
        lastPaymentAmount: 0,
        lastPaymentReference: null,
        transactiontype: null,
    };
    const [formFieldSummaryTotals, setformFieldSummaryTotals] = useState(initialFormFieldSummaryTotals);

    const initialFormFields = {
        name: null,
        address1: null,
        address2: null,
        city: null,
        zip: null,
        state: null,
        creditlimit: null,
        creditlastreviewdate: null,
        creditstatusflag: null,
        creditnextreviewdate: null,
        dateopened: null,
        higheststatementbalance: null,
        creditcomment: null,
        laststatementbalance: null,
        laststatementdate: null,
        creditrating: null,
        totalBalance: null,
        invoiceBalance: null,
        debitBalance: null,
        financeChargeBalance: null,
        // Kept in step with financeChargeBalance above: dynamic-form layout
        // CC645BB7-CC98-4260-B542-A71C4577D1C5 is runtime-overridable, so a customer DB may
        // still hold a saved override carrying the old misspelled field name.
        fnanceChargeBalance: null,
        openOrderAmount: null,
        remainingBal: null,
        under0: null,
        fromZeero: null,
        fromThirtyOne: null,
        fromSixtyOne: null,
        fromNintyOne: null,
        OverOneTwenty: null,
        total: null,
    };


    const [formFields, setformFields] = useState(initialFormFields);
    const handleFieldChange = useCallback((name, value, e) => {
    }, []);
    const handlePrimaryFormLoad = useCallback(async () => {
        if (!props.customerId) {
            return;
        }
        const data = await fetchCustomerCredtData(props.customerId);
        if (!data) {
            return;
        }
        // remainingBal comes from the API (uIDD0021.PAS:435 - creditLimit - (curBalance +
        // openOrders)); computing it here got the operator precedence wrong.
        setformFields(mapCreditData(data));
    }, []);
    const mapCreditData = (data) => {
        const mapped = {
            under0: null,
            fromZeero: null,
            fromThirtyOne: null,
            fromSixtyOne: null,
            fromNintyOne: null,
            OverOneTwenty: null,
            total: 0,
        };

        if (data.creditBreaks) {
            data.creditBreaks.forEach((item, index) => {
                const field = AGING_BUCKET_FIELDS[index];
                if (field) {
                    mapped[field] = item.amount;
                }
                mapped.total += item.amount;
            });
        }

        return {
            ...data,
            ...mapped,
            // Alias for saved layout overrides still referencing the old misspelling.
            fnanceChargeBalance: data.financeChargeBalance,
        };
    };


    const handleSummaryFormLoad = useCallback(async () => {
        // const hasAnyControl = Object.keys(initialFormFieldSummaryTotals).some(
        //     (key) => formRefs.current[key]?.instance !== undefined
        // );
        if (props.customerId) {
            const totals = await fetchSummaryTotalsData(props.customerId);
            mapSummaryTotals(formRefs, totals);
        }
        else {
            mapSummaryTotals(formRefs, initialFormFieldSummaryTotals);
        }
    }, []);
    const mapSummaryTotals = (formRefs, formFieldSummaryTotals) => {
        if(!formFieldSummaryTotals)
            return;
        const fields = {
            InvoiceMTD: formFieldSummaryTotals.invoiceMTD,
            InvoiceYTD: formFieldSummaryTotals.invoiceYTD,
            InvoiceLTD: formFieldSummaryTotals.invoiceLTD,
            InvoicePriorY: formFieldSummaryTotals.invoicePriorY,
            PaymentMTD: formFieldSummaryTotals.paymentMTD,
            PaymentYTD: formFieldSummaryTotals.paymentYTD,
            PaymentLTD: formFieldSummaryTotals.paymentLTD,
            PaymentPriorY: formFieldSummaryTotals.paymentPriorY,
            DiscountMTD: formFieldSummaryTotals.discountMTD,
            DiscountYTD: formFieldSummaryTotals.discountYTD,
            DiscountLTD: formFieldSummaryTotals.discountLTD,
            DiscountPriorY: formFieldSummaryTotals.discountPriorY,
            CreditMTD: formFieldSummaryTotals.creditMTD,
            CreditYTD: formFieldSummaryTotals.creditYTD,
            CreditLTD: formFieldSummaryTotals.creditLTD,
            CreditPriorY: formFieldSummaryTotals.creditPriorY,
            PaidMTD: formFieldSummaryTotals.paidMTD,
            PaidYTD: formFieldSummaryTotals.paidYTD,
            PaidLTD: formFieldSummaryTotals.paidLTD,
            PaidPriorY: formFieldSummaryTotals.paidPriorY,
            PaidDueDateMTD: formFieldSummaryTotals.paidDueDateMTD,
            PaidDueDateYTD: formFieldSummaryTotals.paidDueDateYTD,
            PaidDueDateLTD: formFieldSummaryTotals.paidDueDateLTD,
            PaidDueDatePriorY: formFieldSummaryTotals.paidDueDatePriorY,
            PostedMTD: formFieldSummaryTotals.postedMTD,
            PostedYTD: formFieldSummaryTotals.postedYTD,
            PostedLTD: formFieldSummaryTotals.postedLTD,
            PostedPriorY: formFieldSummaryTotals.postedPriorY,
            PaidLateMTD: formFieldSummaryTotals.paidLateMTD,
            PaidLateYTD: formFieldSummaryTotals.paidLateYTD,
            PaidLateLTD: formFieldSummaryTotals.paidLateLTD,
            PaidLatePriorY: formFieldSummaryTotals.paidLatePriorY,
            AvgDaysPayMTD: formFieldSummaryTotals.avgDaysPayMTD,
            AvgDaysPayYTD: formFieldSummaryTotals.avgDaysPayYTD,
            AvgDaysPayLTD: formFieldSummaryTotals.avgDaysPayLTD,
            AvgDaysPayPriorY: formFieldSummaryTotals.avgDaysPayPriorY,
            CurrentBalance: formFieldSummaryTotals.currentBalance,
            CustomerLASTSTATEMENTDATE: formFieldSummaryTotals.lastStmDate,
            CustomerLASTSTATEMENTBALANCE: formFieldSummaryTotals.lastStmBalance,

            // "Last Invoice" - the control name is legacy; the value is the transaction
            // date (uIDD0021.CustomerLastInfo), not the due date.
            Transactionduedate: formFieldSummaryTotals.transactiondate,
            LastPaymentDate: formFieldSummaryTotals.lastPaymentDate,
            LastStmDate: formFieldSummaryTotals.lastStmDate,
            Transactiontype: TransactionType.find(t => t.code === formFieldSummaryTotals.transactiontype)?.value ?? '',
            Transactionnumber: formFieldSummaryTotals.transactionnumber,
            LastPaymentReference: formFieldSummaryTotals.lastPaymentReference,
            Amt1: formFieldSummaryTotals.amt1,
            LastPaymentAmount: formFieldSummaryTotals.lastPaymentAmount,
            LastStmBalance: formFieldSummaryTotals.lastStmBalance,
        };
        Object.entries(fields).forEach(([key, value]) => {
            if (formRefs.current[key]) {
                formRefs.current[key].instance().option('value', value);
                formRefs.current[key].instance().option('disabled', true);
            }
        });
    }
    const loadLookupFromStaticData = (formRefs, name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'id');
            formRefs.current[name].instance().option('displayExpr', 'name');
            if (props.formFields[name])
                formRefs.current[name].instance().option('value', props.formFields[name]);
        }

    };
    const fetchSummaryTotalsData = async (id) => {
        try {
            setLoadPanelVisible(true);
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/id/Customer/GetSummaryTotals?customerId=${id}&sumaryExtraInfo=${true}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                return res.data;

            } else {
                console.warn("No companies data available.");
            }
        } catch (err) {
            console.log(err, "Error while getting databases");
        }
        finally {
            setLoadPanelVisible(false);
        }
    };
    const fetchCustomerCredtData = async (id) => {
        try {
            setLoadPanelVisible(true);
            const res = await axios.get(
                `${window._env_.REACT_APP_APIS}/id/Customer/GetCustomerCreditInformation?customerId=${id}&module=${props.module}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`
                    }
                }
            );
            if (res.data) {
                return res.data;

            } else {
                console.warn("No companies data available.");
            }
        } catch (err) {
            console.log(err, "Error while getting databases");
        }
        finally {
            setLoadPanelVisible(false);
        }
    };
    const retainersDataSource = new DataSource({
        store: new createStore({
            key: 'rowId',
            loadParams: {
                customerId: function () {
                    return props.customerId;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/id/Customer/GetCustomerRetainers`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        }),
        paginate: true,
        pageSize: 100
    });

    const collectionDataSource = new DataSource({
        store: new createStore({
            key: 'rowId',
            loadParams: {
                customerId: function () {
                    return props.customerId;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/id/Customer/GetCollection`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        }),
        paginate: true,
        pageSize: 100
    });

    return (

        <div ref={rootRef}>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                container={rootRef.current ?? undefined}
                position={rootRef.current ? { my: "center", at: "center", of: rootRef.current } : undefined}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <TabPanel className="TabpanelContainer">
                <TabItem title="Status">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='CC645BB7-CC98-4260-B542-A71C4577D1C5'
                        layoutName='WMTransactionDataEntryCustomerCredit'
                        defaultFormSchema={props.module === "OM" ? OMStatusLayout : StatusLayout}
                        formFields={formFields}
                        setformFields={setformFields}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handlePrimaryFormLoad}
                    />
                </TabItem>
                <TabItem title="Summary">
                    <FormField
                        currrentUser={currentUser}
                        layoutId='CC645BB7-CC98-4260-B542-A71C4577D1C5'
                        layoutName='WMTransactionDataEntryCustomerCredit'
                        defaultFormSchema={SummaryLayout}
                        formFields={formFieldSummaryTotals}
                        setformFields={setformFieldSummaryTotals}
                        handleFieldValueChange={handleFieldChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={formRefs}
                        onFormLoad={handleSummaryFormLoad}
                    />
                </TabItem>
                <TabItem title="Retainers">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        dataSource={retainersDataSource}
                        showBorders={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        remoteOperations={true}
                        hoverStateEnabled={true}
                        height="100%"
                    >
                        <Selection mode="single" />
                        <ColumnHeaderFilter />
                        <Sorting visible={true} mode="multiple" />
                        <GridLoadPanel enabled={true} />
                        <FilterRow visible={true} />
                        <Grouping autoExpandAll={false} />
                        <Column dataField="identityId" caption="Identity ID" dataType="string" />
                        <Column dataField="transactionNumber" caption="Transaction #" dataType="string" />
                        <Column dataField="transactionDate" caption="Trans Date" dataType="date" />
                        <Column dataField="amount" caption="Amount" dataType="number" format="$#,##0.00" />
                        <Column dataField="lastReceivedDate" caption="Last Rcvd" dataType="date" />
                        <Column dataField="lastPaymentAmount" caption="Payments" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                        <Column dataField="balance" caption="Balance" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                    </DataGrid>
                </TabItem>
                <TabItem title="Collections">
                    <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                        dataSource={collectionDataSource}
                        showBorders={true}
                        columnAutoWidth={true}
                        allowColumnResizing={true}
                        allowColumnReordering={true}
                        remoteOperations={true}
                        hoverStateEnabled={true}
                        height="100%"
                    >
                        <Selection mode="single" />
                        <ColumnHeaderFilter />
                        <Sorting visible={true} mode="multiple" />
                        <GridLoadPanel enabled={true} />
                        <FilterRow visible={true} />
                        <Grouping autoExpandAll={false} />
                        {/* Columns and order follow uIDD0021.DFM AbReadOnlyGrid2; the field
                            types follow uIDM0021's qryCollections declarations - STATUS,
                            REFERENCE and DESCRIPTION are string fields, not numbers. */}
                        <Column dataField="rowId" caption="Row Id" dataType="string" visible={false} />
                        <Column dataField="lastUpdateUserId" caption="Last Updated By" dataType="string" />
                        <Column dataField="type" caption="Type" dataType="string" />
                        <Column dataField="status" caption="Status" dataType="string" />
                        <Column dataField="reference" caption="Reference" dataType="string" />
                        <Column dataField="description" caption="Description" dataType="string" />
                        <Column dataField="initialCallDate" caption="Initial Call Date" dataType="date" />
                        <Column dataField="creationDateTime" caption="Creation Date" dataType="datetime" />
                        <Column dataField="creationUserId" caption="Created By" dataType="string" />
                        <Column dataField="lastUpdateDateTime" caption="Last Updated" dataType="datetime" />
                        <Column dataField="comment" caption="Comment" dataType="string" />
                    </DataGrid>
                </TabItem>
            </TabPanel>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(CustomerCredit);